require('./expensesSummaryBoxFilter.scss');

// @vendors
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText, formatText } = require('core/i18n').i18n;
const FiltersContainer = require('components/commons/filters/filtersContainer');
const CheckFilter = require('components/commons/filters/filters/checkFilter');
const RadioFilter = require('components/commons/filters/filters/radioFilter');

// @constants
const {
    ENABLED_CREDIT_CARD_FILTER
} = require ('constants/flagBasedFeatures');
const { PFM_FILTERS } = require('constants/index');
const { ALL_MOVEMENTS, DEBIT_MOVEMENTS, CREDIT_MOVEMENTS, CONTRACT_TYPE, CUSTOM_ACCOUNTS, LAST_MONTH_COMPARISON } = require('constants/expensesByCategories/filters');

class ExpensesSummaryBoxFilter extends Component {

    render() { 
        const {onCloseClick, onSubmit, immFilter, immFlagBasedFeatures} = this.props;

        return (  
            <Fragment>
                <div className="expenses-summary-box__filter__header">
                    <div className="expenses-summary-box__filter__header--close-button">
                        <OKButton modifier="task" inverse={true} onClick={onCloseClick}>
                            <i className="expenses-summary-box__filter__header--close-icon icon-cerrar"></i>
                        </OKButton>
                    </div>
                    <h3 className="expenses-summary-box__filter__header--title">
                        <FormattedText value="myGlobalPositionExpenses-expensesVisualization" format="camelCase" />
                    </h3>
                </div>
                <form className="expenses-summary-box__filter__form">
                    <FiltersContainer filtersId={PFM_FILTERS}>
                        <RadioFilter
                            className="expenses-summary-box__filter__form__input-label"
                            immFilter={immFilter}
                            filtersId={PFM_FILTERS}
                            filterId={CONTRACT_TYPE}
                            initialSelected={ALL_MOVEMENTS}
                            options={[
                                {
                                    label:formatText('myGlobalPositionExpenses-totals'),
                                    value: ALL_MOVEMENTS
                                },
                                {
                                    label:formatText('myGlobalPositionExpenses-onlyFromAccounts'),
                                    value: DEBIT_MOVEMENTS
                                },
                                immFlagBasedFeatures.get(ENABLED_CREDIT_CARD_FILTER) && {
                                    label:formatText('myGlobalPositionExpenses-onlyFromCards'),
                                    value: CREDIT_MOVEMENTS
                                }
                            ].filter(n => n)}
                        />
                        <label className="expenses-summary-box__filter__form--label" htmlFor="expensesSummaryBox__comparative">
                            {formatText('myGlobalPositionExpenses-compareWith')}
                        </label>
                        <CheckFilter  
                            immFilter={immFilter}
                            filtersId={PFM_FILTERS}
                            filterId={LAST_MONTH_COMPARISON}
                            initialValue={false} 
                            label={formatText('myGlobalPositionExpenses-previousMonth')}
                            extraClass="expenses-summary-box__filter__form__input-label"
                        />
                        <label className="expenses-summary-box__filter__form--label" htmlFor="expensesSummaryBox__accountType">
                            {formatText('myGlobalPositionExpenses-typeAccountTitle')}
                        </label>
                        <CheckFilter  
                            immFilter={immFilter}
                            filtersId={PFM_FILTERS}
                            filterId={CUSTOM_ACCOUNTS}
                            initialValue
                            label={formatText('myGlobalPositionExpenses-typeAccountCustom')}
                            extraClass="expenses-summary-box__filter__form__input-label"
                        />
                        <div className="expenses-summary-box__filter__submit-form">
                            <OKButton modifier="secondary" inverse={true} onClick={(e) => onSubmit(e, immFilter)} size="small">{formatText('myGlobalPositionExpenses-apply')}</OKButton>
                        </div>
                    </FiltersContainer>
                </form>
            </Fragment>
        );
    }
}

ExpensesSummaryBoxFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    creditCardFilterEnabled: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired
};
    
module.exports = connect(
    state => ({
        creditCardFilterEnabled: state.flagBasedFeatures.get(ENABLED_CREDIT_CARD_FILTER),
        immFilter: state.filters.get(PFM_FILTERS),
        immFlagBasedFeatures: state.flagBasedFeatures
    })
)(ExpensesSummaryBoxFilter);

